export const capitalize = (text: string) => {
    return text[0].toUpperCase() + text.toLowerCase().substring(1);
}

export const formatZipcode = (input: string) => {
    const stripped = input.replaceAll(/ +/g, "");
    return stripped.substring(0, 4) + " " + stripped.substring(4);
}
